import React from "react";
import useData from "../../../hooks/useData";
import { Col, Popover, Row, Table } from "antd";
import NumberFormat from "../../../utils/NumberFormat";

const Analytics = () => {
  const { data, isLoading } = useData("/sales/contracts");
  const columns = [
    {
      title: "№",
      dataIndex: "number",
      key: "number",
      render: (text, record, index) => index + 1,
      width: 50,
    },
    {
      title: "Договор",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) =>
        a.id
          .split("-")[1]
          .localeCompare(b.id.split("-")[1], undefined, { numeric: true }),
      defaultSortOrder: "descend",
      width: 100,
    },
    {
      title: "Клиент",
      dataIndex: "userData",
      key: "client",
      render: (text, row) =>
        row?.comment || text?.["ru"]?.name || text["ka"].name,
    },
    {
      title: "Стоимость",
      dataIndex: "price",
      key: "price",
      render: (text) => `${NumberFormat(text)} ₾`,
      sorter: (a, b) => a.price - b.price,
    },
    {
      title: "Без НДС",
      dataIndex: "price",
      key: "price",
      render: (text) => `${NumberFormat(text / 1.18)} ₾`,
      sorter: (a, b) => a.price - b.price,
    },
    {
      title: "Расход",
      dataIndex: "price",
      key: "totalExpense",
      render: (text, row) => {
        const priceWithout = text / 1.18;
        const romanSalary = priceWithout * 0.03;
        const expenses = row.totalExpense || 0;
        const designerSalary = priceWithout * 0.07;
        const teamSalary = priceWithout * 0.225;
        return (
          <Popover
            placement={"left"}
            content={
              <>
                <Table
                  dataSource={[
                    { key: "Расход на материалы", value: expenses },
                    { key: "ЗП Дизайнера", value: designerSalary },
                    { key: "ЗП Бригады", value: teamSalary },
                    { key: "ЗП Начальника", value: romanSalary },
                  ]}
                  columns={[
                    { title: "Расход", dataIndex: "key", key: "key" },
                    {
                      title: "Сумма",
                      dataIndex: "value",
                      key: "value",
                      render: (text) => `${NumberFormat(text)} ₾`,
                    },
                  ]}
                  pagination={false}
                />
              </>
            }
          >
            <span style={{ borderBottom: "1px dashed #ddd", cursor: "help" }}>
              {NumberFormat(
                expenses + teamSalary + designerSalary + romanSalary,
              )}{" "}
              ₾
            </span>
          </Popover>
        );
      },
      sorter: (a, b) => {
        const ApriceWithout = a.price / 1.18;
        const AromanSalary = ApriceWithout * 0.03;
        const Aexpenses = a.totalExpense || 0;
        const AdesignerSalary = ApriceWithout * 0.07;
        const AteamSalary = ApriceWithout * 0.225;
        const ATotal = Aexpenses + AteamSalary + AdesignerSalary + AromanSalary;

        const BpriceWithout = b.price / 1.18;
        const BromanSalary = BpriceWithout * 0.03;
        const Bexpenses = b.totalExpense || 0;
        const BdesignerSalary = BpriceWithout * 0.07;
        const BteamSalary = BpriceWithout * 0.225;
        const BTotal = Bexpenses + BteamSalary + BdesignerSalary + BromanSalary;
        return ATotal - BTotal;
      },
    },
    {
      title: "Прибыль",
      dataIndex: "price",
      key: "totalProfit",
      render: (text, row) => {
        const priceWithoutPercent = text / 1.18;
        const romanSalary = priceWithoutPercent * 0.03;
        const expenses = row.totalExpense || 0;
        const designerSalary = priceWithoutPercent * 0.07;
        const teamSalary = priceWithoutPercent * 0.225;
        return `${NumberFormat(
          priceWithoutPercent -
            expenses -
            romanSalary -
            designerSalary -
            teamSalary,
        )}
            ₾
          `;
      },
      sorter: (a, b) => a.price - b.price,
    },
  ];
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header transfer">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Финансовая статистика</h4>
            </div>
          </div>
        </div>
        <Row gutter={16}>
          <Col lg={14}>
            <Table columns={columns} dataSource={data} loading={isLoading} />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Analytics;
